import { Icon } from '@openeducation/oe-rn-components';
import React from 'react';
import { View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import styles from './section-complete.style';
import { useColors } from '../../../hooks';
import { useActivityContext } from '../../../hooks/use-activity.context';
import { Button } from '../../button/button';
import { ThemedView } from '../../themed-view';
import { Title } from '../../title/title.component';

const SectionCompleteGeneric: React.FC = () => {
  const colors = useColors();
  const { goNext } = useActivityContext();

  return (
    <SafeAreaView style={styles.container} edges={['bottom']}>
      <View style={styles.coloredSection}>
        <ThemedView style={styles.blueSection}>
          <Title fontSize="extraLarge" style={styles.title}>
            Great job!
          </Title>
        </ThemedView>
        <ThemedView style={styles.graySection} type="grayLight">
          <Title type="onBackground" style={styles.message}>
            You finished this section succesfully.
          </Title>
        </ThemedView>
        <View style={styles.medalSection}>
          <ThemedView
            type="background"
            style={[
              styles.medalContainer,
              { borderColor: colors.separatorOnBackground },
            ]}
          >
            <Icon name="medal" size={70} color={colors.primary} type="solid" />
          </ThemedView>
        </View>
      </View>
      <View style={styles.whiteSection}>
        <View style={styles.completeButtonContainer}>
          <Button onPress={goNext} backgroundColor={colors.primary}>
            Finish
          </Button>
        </View>
      </View>
    </SafeAreaView>
  );
};

export default SectionCompleteGeneric;
